import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import EventBus from './event-bus'
import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'
import VueEllipsis from './ellipsis'
import VueScroller from 'vue-scroller'

const config = {
locale: 'zh_CN',
errorBagName: 'vErrors'
}

export default () => {
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(EventBus)
Validator.addLocale(zh)
Vue.use(VeeValidate, config)
Vue.use(VueEllipsis)
Vue.use(VueScroller)
Vue.use(WechatPlugin)
}



// WEBPACK FOOTER //
// ./src/plugins/setup.js